export const eventVisibilities = [
  { name: "HIDDEN", value: 0 },
  { name: "VISIBLE", value: 1 },
];
